import { get, post } from '@/request/racmBlockRequest';

let basePath = '/port/msxc';

export function config() {
  return get(basePath + '/config');
}

export function save(params) {
  return post(basePath + '/save', params);
}

export function imageUpload(params) {
  return post('/common/uploads', params);
}

export function deptList(params) {
  return get(basePath + '/dept/list', params);
}
